<template>
  <v-app id="inspire">
    <div>
      <v-layout row justify-center>
        <v-btn color="primary" dark @click.stop="dialog = true">曲検索</v-btn>
        <v-dialog
          v-model="dialog"
          fullscreen
          transition="dialog-bottom-transition"
          :overlay=false
          scrollable
        >
          <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="primary">
              <v-btn icon @click.native="dialog = false" dark>
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>曲検索</v-toolbar-title>
            </v-toolbar>

            <v-card-text style="max-width:700px; margin:0 auto;">
              <div class="table__overflow elevation-1">
                <table class="datatable table">
                <tbody>
                  <tr>
                    <td class="subheading">追加先プレイリスト</td>
                    <td class="text-xs-left">進行プレイリスト</td>
                  </tr>
                  <tr>
                    <td class="subheading">追加先シーン</td>
                    <td class="text-xs-left">
                      シーン名
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <h2 class="title primary--text my-3">検索条件</h2>
              <v-select
                v-model="selectedScenes"
                :items="$store.state.searchTuneOption.scenes"
                item-text="sceneName"
                item-value="id"
                label="シーンを選択"
                chips
                clearable
                multiple
              >
              </v-select>

              <v-select
                v-model="selectedTags"
                :items="$store.state.searchTuneOption.tags"
                item-text="tagName"
                item-value="id"
                label="タグを選択"
                chips
                clearable
                multiple
              >
              </v-select>
              <v-btn color="blue darken-1" @click.native="dialog = false" dark>検索</v-btn>
              <v-divider class="my-4"></v-divider>
              <h2 class="title primary--text my-3">検索結果</h2>
              <v-list two-line>
                <v-list-tile avatar class="itemDivider">
                  <v-list-tile-avatar>
                    <v-icon class="btn-hover" large color="primary">play_circle_outline</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>曲のタイトル</v-list-tile-title>
                    <router-link :to="'/home/artist/detail/'">
                      <v-list-tile-sub-title>アーティスト名</v-list-tile-sub-title>
                    </router-link>
                  </v-list-tile-content>
                  <v-spacer></v-spacer>
                  <v-btn flat icon color="red">
                    <v-icon>report_problem</v-icon>
                  </v-btn>
                  <v-btn flat icon color="green">
                    <v-icon>library_books</v-icon>
                  </v-btn>
                  <v-btn flat icon color="green">
                    <v-icon>add_circle_outline</v-icon>
                  </v-btn>
                </v-list-tile>
              </v-list>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'ModalDev',
  data () {
    return {
      dialog: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ModalDev.vue